import { render, staticRenderFns } from "./TreeViewItem.vue?vue&type=template&id=519ac98b&scoped=true"
import script from "./TreeViewItem.vue?vue&type=script&lang=js"
export * from "./TreeViewItem.vue?vue&type=script&lang=js"
import style0 from "./TreeViewItem.vue?vue&type=style&index=0&id=519ac98b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519ac98b",
  null
  
)

export default component.exports